import { defineWidget } from '../widget-types';
import type { BlockNode } from '../block-types';

const announcementBarDefaultBlocks: BlockNode[] = [
  {
    id: 'ab-icon',
    type: 'icon',
    content: { type: 'icon', name: 'megaphone', size: 18 },
    layout: { order: 0, widthPct: 25, align: 'center' },
  },
  {
    id: 'ab-message',
    type: 'text',
    content: { type: 'text', value: 'Welcome to our store!', fontSize: 14, fontWeight: 500, textAlign: 'center' },
    layout: { order: 1, widthPct: 75 },
  },
];

export const announcementBarWidget = defineWidget({
  type: 'announcement-bar',
  schema: {
    label: 'Announcement Bar',
    description: 'Top-of-page announcement banner with optional link',
    props: {
      message: {
        type: 'string',
        label: 'Message',
        default: 'Welcome to our store!',
      },
      linkText: {
        type: 'string',
        label: 'Link Text',
      },
      linkHref: {
        type: 'link',
        label: 'Link URL',
      },
    },
    slots: {
      message: {
        type: 'text',
        label: 'Announcement Message',
      },
    },
    dataDeps: [],
  },
  nameTh: 'แถบประกาศ',
  descriptionTh: 'แถบประกาศด้านบนหน้าเว็บพร้อมลิงก์',
  category: 'content',
  thumbnail: '/widget-thumbnails/announcement-bar.svg',
  defaults: {
    type: 'announcement-bar',
    props: { message: 'Welcome to our store!' },
    slots: {
      message: { value: 'Welcome to our store!' },
    },
  },
  defaultBlocks: announcementBarDefaultBlocks,
});
